// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";

import moment from "moment";
import { getPricingTemplates } from "network/service";
import { useNavigate } from "react-router-dom";

import * as XLSX from 'xlsx';
import TableData from "./data";
import AddEditTemplatePopup from "./components/AddTemplatePopup/AddTemplatePopup";


export default function PricingTemplates() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const { formTemplateRows, templateHeaders } = TableData();
    const [templatepopup, setTemplatePopp] = useState({ visible: false, details: null });

    const exportToExcel = (filename, details) => {
        const ws = XLSX.utils.json_to_sheet(details);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, `${filename}.xlsx`);
    };

    const fetchPricingTemplates = async () => {
        getPricingTemplates().then((resp) => {
            setData(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }


    useEffect(() => {
        // getPricingTemplates().then((resp) => {
        //     setData(resp.data);
        // }).catch((err) => {
        //     console.log(err);
        // })
        fetchPricingTemplates();
    }, [setData]);


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}><Grid container spacing={6}>
                {
                    templatepopup.visible && <AddEditTemplatePopup
                        isopen={templatepopup.visible}
                        handleclose={() => {
                            setTemplatePopp({ visible: false, details: null });
                        }}
                        handlesuccess={() => {
                            setTemplatePopp({ visible: false, details: null });
                            fetchPricingTemplates();
                        }} />
                }
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white">
                                Templates
                            </MDTypography>
                        </MDBox>
                        <MDBox
                            mx={2}
                            mt={0}
                            py={2}
                            px={0}
                            borderRadius="lg"
                            alignSelf="flex-end"
                        >
                            <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                onClick={async () => {
                                    setTemplatePopp({ visible: true, details: null });
                                }}>
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                &nbsp;Add
                            </MDButton>
                        </MDBox>
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: templateHeaders, rows: formTemplateRows(data) }}
                                canSearch
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
            </MDBox>
        </DashboardLayout>
    );
}